import { render, staticRenderFns } from "./ClassLoft.vue?vue&type=template&id=2b52b178&scoped=true"
import script from "./ClassLoft.vue?vue&type=script&lang=js"
export * from "./ClassLoft.vue?vue&type=script&lang=js"
import style0 from "./ClassLoft.vue?vue&type=style&index=0&id=2b52b178&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b52b178",
  null
  
)

export default component.exports